module.exports = __webpack_public_path__ + "img/志愿资讯.839348c6.png";